import _reduce from "lodash/reduce.js";
import _debounce from "lodash/debounce.js";
function cov_2a390ikrrf() {
  var path = "/__w/code/code/js/packages/bricks/src/deprecated/UNSAFE_Responsive.tsx";
  var hash = "2ed389ce5cdffcf47630aa0f9b79b998244ffa3e";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/deprecated/UNSAFE_Responsive.tsx",
    statementMap: {
      "0": {
        start: {
          line: 12,
          column: 18
        },
        end: {
          line: 12,
          column: 39
        }
      },
      "1": {
        start: {
          line: 50,
          column: 28
        },
        end: {
          line: 50,
          column: 32
        }
      },
      "2": {
        start: {
          line: 53,
          column: 4
        },
        end: {
          line: 53,
          column: 17
        }
      },
      "3": {
        start: {
          line: 55,
          column: 4
        },
        end: {
          line: 57,
          column: 6
        }
      },
      "4": {
        start: {
          line: 61,
          column: 4
        },
        end: {
          line: 61,
          column: 66
        }
      },
      "5": {
        start: {
          line: 62,
          column: 4
        },
        end: {
          line: 62,
          column: 60
        }
      },
      "6": {
        start: {
          line: 66,
          column: 4
        },
        end: {
          line: 66,
          column: 63
        }
      },
      "7": {
        start: {
          line: 70,
          column: 4
        },
        end: {
          line: 73,
          column: 7
        }
      },
      "8": {
        start: {
          line: 76,
          column: 25
        },
        end: {
          line: 82,
          column: 3
        }
      },
      "9": {
        start: {
          line: 77,
          column: 26
        },
        end: {
          line: 77,
          column: 48
        }
      },
      "10": {
        start: {
          line: 79,
          column: 4
        },
        end: {
          line: 81,
          column: 5
        }
      },
      "11": {
        start: {
          line: 80,
          column: 6
        },
        end: {
          line: 80,
          column: 51
        }
      },
      "12": {
        start: {
          line: 84,
          column: 34
        },
        end: {
          line: 86,
          column: 3
        }
      },
      "13": {
        start: {
          line: 85,
          column: 4
        },
        end: {
          line: 85,
          column: 83
        }
      },
      "14": {
        start: {
          line: 88,
          column: 31
        },
        end: {
          line: 97,
          column: 3
        }
      },
      "15": {
        start: {
          line: 89,
          column: 4
        },
        end: {
          line: 96,
          column: 6
        }
      },
      "16": {
        start: {
          line: 92,
          column: 8
        },
        end: {
          line: 92,
          column: 84
        }
      },
      "17": {
        start: {
          line: 93,
          column: 8
        },
        end: {
          line: 93,
          column: 31
        }
      },
      "18": {
        start: {
          line: 99,
          column: 27
        },
        end: {
          line: 110,
          column: 3
        }
      },
      "19": {
        start: {
          line: 100,
          column: 23
        },
        end: {
          line: 100,
          column: 62
        }
      },
      "20": {
        start: {
          line: 101,
          column: 4
        },
        end: {
          line: 109,
          column: 6
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 52,
            column: 2
          },
          end: {
            line: 52,
            column: 3
          }
        },
        loc: {
          start: {
            line: 52,
            column: 21
          },
          end: {
            line: 58,
            column: 3
          }
        },
        line: 52
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 60,
            column: 2
          },
          end: {
            line: 60,
            column: 3
          }
        },
        loc: {
          start: {
            line: 60,
            column: 29
          },
          end: {
            line: 63,
            column: 3
          }
        },
        line: 60
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 65,
            column: 2
          },
          end: {
            line: 65,
            column: 3
          }
        },
        loc: {
          start: {
            line: 65,
            column: 32
          },
          end: {
            line: 67,
            column: 3
          }
        },
        line: 65
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 69,
            column: 2
          },
          end: {
            line: 69,
            column: 3
          }
        },
        loc: {
          start: {
            line: 69,
            column: 18
          },
          end: {
            line: 74,
            column: 3
          }
        },
        line: 69
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 76,
            column: 25
          },
          end: {
            line: 76,
            column: 26
          }
        },
        loc: {
          start: {
            line: 76,
            column: 31
          },
          end: {
            line: 82,
            column: 3
          }
        },
        line: 76
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 84,
            column: 34
          },
          end: {
            line: 84,
            column: 35
          }
        },
        loc: {
          start: {
            line: 84,
            column: 63
          },
          end: {
            line: 86,
            column: 3
          }
        },
        line: 84
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 88,
            column: 31
          },
          end: {
            line: 88,
            column: 32
          }
        },
        loc: {
          start: {
            line: 88,
            column: 55
          },
          end: {
            line: 97,
            column: 3
          }
        },
        line: 88
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 91,
            column: 6
          },
          end: {
            line: 91,
            column: 7
          }
        },
        loc: {
          start: {
            line: 91,
            column: 52
          },
          end: {
            line: 94,
            column: 7
          }
        },
        line: 91
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 99,
            column: 27
          },
          end: {
            line: 99,
            column: 28
          }
        },
        loc: {
          start: {
            line: 99,
            column: 47
          },
          end: {
            line: 110,
            column: 3
          }
        },
        line: 99
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 79,
            column: 4
          },
          end: {
            line: 81,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 79,
            column: 4
          },
          end: {
            line: 81,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 79
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "2ed389ce5cdffcf47630aa0f9b79b998244ffa3e"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2a390ikrrf = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2a390ikrrf();
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function () { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Component } from 'react';
import { BREAKPOINTS_DICT, BREAKPOINTS_SORTED_LIST, getCurrentBreakpoint } from "../theme/legacy/foundations/mediaBreakpoints.mjs";
const FPS_60_MS = (cov_2a390ikrrf().s[0]++, Math.floor(1000 / 60));

// we could also pass in the current max breakpoint width.
// at call site we'd do (maxBreakpointWidth > BREAKPOINTS['M']).
// pros: less data passed through
// cons: need to import 'BREAKPOINTS' to use
/**
 * @deprecated in favor of src/hooks/useMedia
 */
let UNSAFE_Responsive = /*#__PURE__*/function (_Component) {
  _inherits(UNSAFE_Responsive, _Component);
  // for resize handler in mount/unmount

  function UNSAFE_Responsive(props) {
    var _this;
    _classCallCheck(this, UNSAFE_Responsive);
    cov_2a390ikrrf().f[0]++;
    cov_2a390ikrrf().s[2]++;
    _this = _callSuper(this, UNSAFE_Responsive, [props]);
    _defineProperty(_assertThisInitialized(_this), "debouncedResize", (cov_2a390ikrrf().s[1]++, null));
    _defineProperty(_assertThisInitialized(_this), "handleResize", (cov_2a390ikrrf().s[8]++, () => {
      cov_2a390ikrrf().f[4]++;
      const newBreakpoint = (cov_2a390ikrrf().s[9]++, getCurrentBreakpoint());
      cov_2a390ikrrf().s[10]++;
      if (_this.state.breakpoint !== newBreakpoint) {
        cov_2a390ikrrf().b[0][0]++;
        cov_2a390ikrrf().s[11]++;
        _this.setState({
          breakpoint: newBreakpoint
        });
      } else {
        cov_2a390ikrrf().b[0][1]++;
      }
    }));
    _defineProperty(_assertThisInitialized(_this), "isViewportGreaterThan", (cov_2a390ikrrf().s[12]++, breakpoint => {
      cov_2a390ikrrf().f[5]++;
      cov_2a390ikrrf().s[13]++;
      return BREAKPOINTS_DICT[_this.state.breakpoint] >= BREAKPOINTS_DICT[breakpoint];
    }));
    _defineProperty(_assertThisInitialized(_this), "getBreakpointState", (cov_2a390ikrrf().s[14]++, () => {
      cov_2a390ikrrf().f[6]++;
      cov_2a390ikrrf().s[15]++;
      return _reduce(BREAKPOINTS_SORTED_LIST, (breakpointState, breakpoint) => {
        cov_2a390ikrrf().f[7]++;
        cov_2a390ikrrf().s[16]++;
        breakpointState["gt".concat(breakpoint)] = _this.isViewportGreaterThan(breakpoint);
        cov_2a390ikrrf().s[17]++;
        return breakpointState;
      }, {});
    }));
    _defineProperty(_assertThisInitialized(_this), "getDeviceState", (cov_2a390ikrrf().s[18]++, () => {
      cov_2a390ikrrf().f[8]++;
      const breakpoint = (cov_2a390ikrrf().s[19]++, BREAKPOINTS_DICT[_this.state.breakpoint]);
      cov_2a390ikrrf().s[20]++;
      return {
        LG: breakpoint === BREAKPOINTS_DICT['LG'],
        MD: breakpoint === BREAKPOINTS_DICT['MD'],
        SM: breakpoint === BREAKPOINTS_DICT['SM'],
        XL: breakpoint === BREAKPOINTS_DICT['XL'],
        XS: breakpoint === BREAKPOINTS_DICT['XS'],
        XXS: breakpoint === BREAKPOINTS_DICT['XXS'],
        XXL: breakpoint === BREAKPOINTS_DICT['XXL']
      };
    }));
    cov_2a390ikrrf().s[3]++;
    _this.state = {
      breakpoint: getCurrentBreakpoint()
    };
    return _this;
  }
  _createClass(UNSAFE_Responsive, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      cov_2a390ikrrf().f[1]++;
      cov_2a390ikrrf().s[4]++;
      this.debouncedResize = _debounce(this.handleResize, FPS_60_MS);
      cov_2a390ikrrf().s[5]++;
      window.addEventListener('resize', this.debouncedResize);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cov_2a390ikrrf().f[2]++;
      cov_2a390ikrrf().s[6]++;
      window.removeEventListener('resize', this.debouncedResize);
    }
  }, {
    key: "render",
    value: function render() {
      cov_2a390ikrrf().f[3]++;
      cov_2a390ikrrf().s[7]++;
      return this.props.render(_objectSpread(_objectSpread({}, this.getBreakpointState()), this.getDeviceState()));
    }
  }]);
  return UNSAFE_Responsive;
}(Component);
export default UNSAFE_Responsive;